import api from './'

export default {

    /**
     * Get spending limits
     * @param walletId
     * @param params
     */
    getSpendingLimits(walletId, params) {
        return api
            .get(`/wallets/${walletId}/spendingLimits`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Set spending limits
     * @param walletId
     * @param data
     */
    setSpendingLimits(walletId, data) {
        return api
            .post(`/wallets/${walletId}/spendingLimits`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get types
     * @param walletId
     * @param params
     */
    getTypes(walletId, params) {
        return api
            .get(`/wallets/${walletId}/types`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Set types
     * @param walletId
     * @param data
     */
    setTypes(walletId, data) {
        return api
            .post(`/wallets/${walletId}/types`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get wallets
     * @param params
     */
    get(params) {
        return api
            .get(`/wallets`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show wallet
     * @param walletId
     * @param params
     */
    show(walletId, params) {
        return api
            .get(`/wallets/${walletId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Enable a wallet
     * @param walletId
     * @param data
     */
    enable(walletId, data) {
        return api
            .post(`/wallets/${walletId}/enable`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Disable a wallet
     * @param walletId
     * @param data
     */
    disable(walletId, data) {
        return api
            .post(`/wallets/${walletId}/disable`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Deposit on wallet
     * @param walletId
     * @param data
     */
    deposit(walletId, data) {
        return api
            .post(`/wallets/${walletId}/deposit`, data)
            .then(response => {
                return response.data
            })
    },

        /**
     * Transfer amount to another wallet
     * @param walletId
     * @param data
     */
    transfer(walletId, data) {
        return api
            .post(`/wallets/${walletId}/transfer`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get deposits transactions of a wallet
     * @param walletId
     * @param params
     */
    getDeposits(walletId, params) {
        return api
            .get(`/wallets/${walletId}/deposits`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Withdraw from wallet
     * @param walletId
     * @param data
     */
    withdraw(walletId, data) {
        return api
            .post(`/wallets/${walletId}/withdraw`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get transactions
     * @param walletId
     * @param params
     */
    getTransactions(walletId, params) {
        return api
            .get(`/wallets/${walletId}/transactions`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get frozen amounts
     * @param walletId
     * @param params
     */
    getFrozenAmounts(walletId, params) {
        return api
            .get(`/wallets/${walletId}/frozen`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create card
     * @param walletId
     * @param data
     */
    createCard(walletId, data) {
        return api
            .post(`/wallets/${walletId}/card`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get card
     * @param walletId
     * @param params
     */
    getCards(walletId, params) {
        return api
            .get(`/wallets/${walletId}/cards`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
